import { render, staticRenderFns } from "./RadioSelection.vue?vue&type=template&id=12806705&scoped=true"
import script from "./RadioSelection.vue?vue&type=script&lang=js"
export * from "./RadioSelection.vue?vue&type=script&lang=js"
import style0 from "./RadioSelection.vue?vue&type=style&index=0&id=12806705&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12806705",
  null
  
)

export default component.exports